var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53049 2.80301C4.38984 2.66236 4.19907 2.58334 4.00016 2.58334C3.80125 2.58334 3.61048 2.66236 3.46983 2.80301L0.803166 5.46968C0.510273 5.76257 0.510273 6.23745 0.803166 6.53034C1.09606 6.82323 1.57093 6.82323 1.86383 6.53034L3.25016 5.144V12.6667C3.25016 13.0809 3.58595 13.4167 4.00016 13.4167C4.41438 13.4167 4.75016 13.0809 4.75016 12.6667V5.144L6.1365 6.53034C6.42939 6.82323 6.90427 6.82323 7.19716 6.53034C7.49005 6.23745 7.49005 5.76257 7.19716 5.46968L4.53049 2.80301Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 10.856V3.33334C12.7502 2.91913 12.4144 2.58334 12.0002 2.58334C11.5859 2.58334 11.2502 2.91913 11.2502 3.33334V10.856L9.86383 9.46968C9.57093 9.17679 9.09606 9.17679 8.80317 9.46968C8.51027 9.76257 8.51027 10.2374 8.80317 10.5303L11.4698 13.197C11.6105 13.3377 11.8013 13.4167 12.0002 13.4167C12.1991 13.4167 12.3898 13.3377 12.5305 13.197L15.1972 10.5303C15.4901 10.2374 15.4901 9.76257 15.1972 9.46968C14.9043 9.17679 14.4294 9.17679 14.1365 9.46968L12.7502 10.856Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.c510ffdbb67f039dd37903755f72eb3d.svg";
export { ForwardRef as ReactComponent };